import { IcoRemove } from '@/utils/icons'
import cn from './index.module.css'
import Modal from '@common/Modal'
import TextField from '../../components/TextField/TextField'
import { useState } from 'react'
import SecondaryButton from '../../components/SecondaryButton/SecondaryButton'
import { Spin } from 'antd'
import { LoadingOutlined } from '@ant-design/icons'
import { useAddAlert } from '@/hooks/useAddAlert'
import { thematicsAPI } from '@/api'

interface IFolder {
  id: number
  name: string
  view: number
}

const CreateFolderModal = ({
  isVisible,
  onDismiss = () => {},
  onCreate = (folder) => {},
}: {
  isVisible: boolean
  onDismiss: () => void
  onCreate: (folder: IFolder) => void
}) => {
  return (
    <Modal
      active={isVisible}
      setActive={onDismiss}
      // @ts-ignore
      className={cn.modalWrapper}
    >
      <CreateFolderModalBody onCreate={onCreate} onDismiss={onDismiss} />
    </Modal>
  )
}

const CreateFolderModalBody = ({
  onDismiss = () => {},
  onCreate = (folder) => {},
}: {
  onDismiss: () => void
  onCreate: (folder: IFolder) => void
}) => {
  const addAlert = useAddAlert()
  const [name, setName] = useState('')
  const [isSaving, setIsSaving] = useState(false)
  const [error, setError] = useState(false)

  const createFolder = () => {
    if (isSaving) return
    if (!name) {
      setError(true)
      return
    }
    setIsSaving(true)

    thematicsAPI
      .add({ data: { name: name, view: 1 } })
      .then((res) => {
        if (res?.data?.status === 'success' || res?.data?.id) {
          addAlert({ title: 'Папка создана!' })
          onCreate(res?.data)
        } else
          addAlert({
            type: 'error',
            title:
              'Упс! Ошибка. Попробуйте ещё раз или обратитесь к администратору',
          })
      })
      .catch((error) => {
        addAlert({
          type: 'error',
          title:
            'Упс! Ошибка. Попробуйте ещё раз или обратитесь к администратору',
        })
      })
      .finally(() => setIsSaving(false))
  }

  return (
    <div className={cn.modalContainer}>
      <div className={cn.modalHeader}>
        <div className={cn.modalTitleContainer}>
          <span className={cn.modalHeaderTitle}>Создать папку</span>
        </div>
        <div className={cn.closeIcon} onClick={onDismiss}>
          <IcoRemove />
        </div>
      </div>
      <div className={cn.content}>
        <TextField
          label="Введите название папки"
          placeholder='Новая папка'
          value={name}
          onChange={setName}
          className={cn.textField}
          isInvalid={error}
        />
      </div>
      <div className={cn.footer}>
        {isSaving && (
          <Spin
            indicator={
              <LoadingOutlined
                spin
                onPointerEnterCapture={undefined}
                onPointerLeaveCapture={undefined}
              />
            }
          />
        )}
        <SecondaryButton onClick={createFolder} disabled={isSaving}>
          Создать
        </SecondaryButton>
      </div>
    </div>
  )
}

export default CreateFolderModal